/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'projector': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16.052 32A3 3 0 0017 26.172V24h11a1 1 0 000-2h-1V10a2.002 2.002 0 002-2V6a2.002 2.002 0 00-2-2H5a2.002 2.002 0 00-2 2v2a2.002 2.002 0 002 2v12H4a1 1 0 000 2h11v2.172A3 3 0 0015.948 32h.104zm-3.345-13.293A1 1 0 0013 18v-2a1 1 0 00-2 0v2a1 1 0 001.707.707zm2.737 11.124a1 1 0 101.111-1.662 1 1 0 00-1.11 1.662zm1.263-11.124A1 1 0 0017 18v-3a1 1 0 00-2 0v3a1 1 0 001.707.707zm4 0A1 1 0 0021 18v-4a1 1 0 00-2 0v4a1 1 0 001.707.707zM5 6v2h22.001L27 6H5z" _fill="#0B2C62"/>'
  }
})
